import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../interface/field.interface";

@Component({
    selector: "form-field-label",
    templateUrl: './label.component.html'
})
export class LabelComponent implements OnInit {
    field!: FieldConfig;
    group!: FormGroup;
    formName:string = '';
    labelValue:string = '';
    ngOnInit() {
        if(!!this.field.value){
            this.labelValue = this.field.value.value;
        }
    }

}
